import React, { useState, useEffect, useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { deleteFundTransfer, getOneFundTransfer } from "../../redux/actions/fundTransfer.action";
import CrudButtons from "./components/CrudButtons";
import FundTransferForm from "./components/Form/FundTransferForm";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Button } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import notification from "../../utils/notification";
import "../../screens/Product/product.css";
import "../Style/style.css";
import { getRights } from "../../redux/actions/userRights.action";
import { TabTitle } from "../../utils/GeneralFunction";
import { getTransationLock } from "../../redux/actions/transactionLock.action";
import moment from "moment";

export default function FundTransfer({ token }) {
	TabTitle("Fund Transfer")
	const dispatch = useDispatch();
	const history = useHistory();
	const { id } = useParams();

	const dCompanyId = ReadCookie("defaultCompany");
	const { log, fundTransfer } = useSelector((state) => state);
	const [minimize, setMinimize] = useState(false);
	const [formState, setFormState] = useState("view");
	const [flag, setFlag] = useState(false);

	const [companyId, setCompanyId] = useState(ReadCookie("defaultCompany"));
	const [disable, setDisable] = useState(false);
	const [submit, setSubmit] = useState(false);
	const queryParams = new URLSearchParams(window.location.search);
	const mode = queryParams.get("mode");
	const [userRights, setUserRights] = useState({})
	const [transactionLock, setTransactionLock] = useState(false)


	useLayoutEffect(() => {
	  dispatch(getRights(token, 1101)).then((res) => {
		
		if (res.type === "GET_USER_RIGHTS_SUCCESS") {
		  setUserRights(res?.payload)
		}
	  });
	}, [token])


	const filterReset = () => {
		setFormState("view");
	};

	const handleDelete = () => {
		dispatch(deleteFundTransfer(token, id)).then((res) => {
			if (res.type === "DELETE_FUND_TRANSFER_SUCCESS") {
				notification("success", "Fund Transfer Deleted","Fund Transfer deleted successfully",
				 res.payload,
				 "Record deleted successfully");
				setFlag(true);
				history.push("/transfer/list");
			}
		});
	};

	const formSave = () => {
		setSubmit(true);
		setDisable(true)
	};
	useEffect(() => {
		if (mode === "add") {
			setFormState("add");
		}
	}, [mode]);

	
	
	

	useEffect(() => {
		if (id) {
			setFormState("formView");
			dispatch(getOneFundTransfer(token, id)).then((res) => {
				if(res?.type === "GET_ONE_FUND_TRANSFER_SUCCESS") {

					if (res?.payload?.data[0]?.transfer_date) {
					
						let transaction_date = moment(res?.payload.data[0]?.transfer_date).format("YYYY-MM-DD");
						dispatch(getTransationLock(token, transaction_date)).then((r) => {
						
							if (r.payload.data.length > 0) {
								setTransactionLock(true);
							}
						});
					}
				}
			});
		}
	}, [id]);

	return (
		<>
			<div className="styleContainer">
				<div className="styleBody h-100">
					<PageHeader title={"Fund Transfer"} minimize={setMinimize} check={minimize} />
					<div className="bodyStyle">
						<div className="crudDiv">
							<CrudButtons
								id={id}
								name={"saleOrder"}
								reset={filterReset}
								userRights={userRights}
								formType={formState}
								save={formSave}
								disable={disable}
								formState={setFormState}
								onDelete={handleDelete}
								saleOrderID={id}
								formData={fundTransfer?.payload?.data}
								transactionLock={transactionLock}
							/>
							<div className="mainProductContainer">
								<FundTransferForm
									dCompany={dCompanyId}
									defaultCompany={companyId}
									companyId={setCompanyId}
									submit={setSubmit}
									val={submit}
									formData={formState === "formView" || formState === "edit" ? fundTransfer?.payload?.data[0] : null}
									formState={formState}
									changeState={setFormState}
									token={token}
									checkFlag={flag}
									setFlag={setFlag}
									logs={log}
									saleOrderID={id}
									transactionLock={transactionLock}
									setDisable={setDisable}
								/>
							</div>
						</div>
					</div>
				</div>
				{minimize && (
					<div className="styleFooter">
						{" "}
						<Button className="minimize-button-style" onClick={() => setMinimize(false)}>
							{" "}
							Item Transfer{" "}
						</Button>{" "}
					</div>
				)}
			</div>
		</>
	);
}
